<template>
  <van-popup v-model="dialogVisible" round position="bottom">
    <div class="prompt-popup2">
      <img
        class="swiper-close"
        src="@/assets/images/swiper-close.png"
        alt=""
        @click="dialogVisible = false"
      />
      <div class="popup-title">
        <img src="@/assets/images/ic_about_logo.png" alt="" />
        <div class="desk-info">
          <h1>快速添加桌面应用</h1>
          <span>便捷启动·全屏体验</span>
        </div>
      </div>
      <swiper :options="swiperOption" ref="mySwiper" class="swiper">
        <swiper-slide
          v-for="(item, i) in popupList"
          :key="i"
          class="swiper_item"
        >
          <div
            class="img"
            :style="{
              background: `url(${item.popupUrl})`,
              'background-size': '100% 100%',
            }"
          >
            <img
              class="carousel"
              :src="require(`@/assets/images/carousel-${i}.png`)"
              alt=""
            />
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </van-popup>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    //定义这个swiper对象
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  data() {
    return {
      swiperOption: {
        effect: "coverflow",
        centeredSlides: true,
        spaceBetween: "11%",
        slidesPerView: "auto",
        loop: true,
        autoplay: true, // 是否自动播放
        touchRatio: 2,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        },
      },
      popupList: [
        {
          popupUrl: require("@/assets/images/popup2-swiper1.png"),
        },
        {
          popupUrl: require("@/assets/images/popup2-swiper2.png"),
        },
        {
          popupUrl: require("@/assets/images/popup2-swiper3.png"),
        },
      ],
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss">
.prompt-popup2 {
  padding: 30px;
  .swiper-close {
    width: 48px;
    height: 48px;
    position: absolute;
    right: 30px;
    top: 20px;
    z-index: 999;
  }
  .swiper-container {
    width: 650px;
    height: 400px;
    // overflow: visible !important;
  }

  .swiper-wrapper .swiper-slide {
    width: 650px;
    height: 400px;
    border-radius: 32px;
  }

  .swiper-wrapper .swiper-slide .img {
    position: relative;
    width: 650px;
    height: 400px;
    background-size: 100% 100%;
    border-radius: 32px;
  }
  .carousel {
    width: 100px;
    height: 30px;
    position: absolute;
    bottom: 10px;
    left: 275px;
  }
  .popup-title {
    display: flex;
    align-items: flex-start;
    margin-bottom: 30px;
    img {
      width: 110px;
      height: 110px;
      margin-right: 20px;
    }
    .desk-info {
      h1 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 34px;
        color: #222222;
        line-height: 48px;
        margin-bottom: 10px;
      }
      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 24px;
        color: #adadad;
        line-height: 33px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PromptPopup2.vue